import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import { Grid, Box, Switch, IconButton, TextField } from "@mui/material";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";

import { makeStyles } from "@material-ui/core/styles";
import {
    InputLabel,
    MenuItem,
    FormControl,
    Select,
    Typography,
} from "@mui/material";
import { uniqBy, find, sortBy, map, filter, orderBy } from "lodash";
import { getAllAssignedBooks, getUserLog } from "./Services";
import { getAsset, getClassNames, joinByKeys } from "../../Js/Common";
import { getFormatedDate } from "../../Js/TimeAndDate";
import { getRolesBySiteUuid, getUsersByRoleId } from "../Users/Services";
import { commonSliceActions } from "../../Store/Slices/CommonSlice";
import html2pdf from 'html2pdf.js';

const ReaderBoardCertificate = (props) => {
    const dispatch = useDispatch();
    const styles = useStyles();

    let [allClasses, setAllClasses] = useState([]);
    let [books, setBooks] = useState([]);
    let [learners, setLearners] = useState([]);
    let [trainers, setTrainers] = useState([]);
    let [selectedTrainers, setSelectedTrainers] = useState([]);
    let [selectedClass, setselectedClass] = useState("");


    let [selectedSort, setselectedSort] = useState("Name");
    let [isActive, setIsActive] = useState(false);
    let [assessmentYearItems, setAssessmentYearItems] = useState([
        { 'label': '2023-2024', 'value': '2023-04-01_2024-03-31' },
        { 'label': '2024-2025', 'value': '2024-04-01_2025-03-31' }
    ]);
    let [selectedAssessmentYear, setSelectedAssessmentYear] = useState(null);
    let [assessmentYear, setAssessmentYear] = useState(assessmentYearItems[0].label);


    // Redux state
    const userInfo = useSelector((state) => state.loggedInUserInfo.userInfo);
    const { siteConfig } = useSelector((state) => state.defs);
    const { paramsdata } = useSelector((state) => state.common);

    let [instituteName, setInstituteName] = useState(siteConfig.customer.customerName);
    let [selectedClassName, setSelectedClassName] = useState("");

    let serverRole = siteConfig.serverRole;

    useEffect(() => {
        let innerFun = async () => {
            let createdBy = [userInfo.uid];

            dispatch(commonSliceActions.setLoader(true));
            if (userInfo.rolesInfo.title.toLowerCase() != "trainer") {
                let userdata = await fetchRoleWiseUser("Trainer");
                setTrainers(userdata.data);
                createdBy = map(userdata.data, "uid");
                setSelectedTrainers(createdBy);
            }
            getAssignedBooks(createdBy);
        };
        innerFun();
    }, []);

    useEffect(() => {
        if (selectedClass != "") {
            standardName(selectedClass);
        }
    }, [selectedClass]);

    useEffect(() => {
        if (selectedAssessmentYear) {
            dispatch(commonSliceActions.setLoader(true));
            fetchLearners(selectedClass, books);
        }
    }, [selectedAssessmentYear])


    let getAssignedBooks = async (createdBy) => {
        let AllBooks = await getAllAssignedBooks({
            tasktype: "library",
            site_uuid: userInfo.site_uuid,
            created_by: createdBy,
            $limit: -1,
        });

        let uniqBooks = [];

        AllBooks.data.forEach((val, index) => {
            if (uniqBooks.indexOf(val.data1.exersices[0]) == -1) {
                uniqBooks.push(val.data1.exersices[0]);
            }
        });

        let assetData = await getAsset({
            $in: uniqBooks,
        });
        let sortedBooks = sortBy(assetData.data, [
            (o) => {
                return o.asset_name;
            },
        ]);

        setBooks(sortedBooks);
        let classData = await getClassNames(userInfo.site_uuid);
        console.log("allClasses", classData);
        setAllClasses(classData);
        if (classData.length > 0) {
            setselectedClass(classData[0].id);
            fetchLearners(classData[0].id, sortedBooks);
        }
    };

    const fetchRoleWiseUser = async (type, id = null) => {
        let params = {
            query: {
                $select: ["uid", "title"],
                site_uuid: userInfo.site_uuid,
            },
        };
        let resRolesData = await getRolesBySiteUuid(params);
        let learnerRole = find(resRolesData.data, { title: type });

        let params1 = {
            query: {
                $select: ["uid", "name"],
                $limit: -1,
                role_uid: learnerRole.uid,
                site_uuid: userInfo.site_uuid,
                status: true,
            },
        };

        if (id) {
            params1.query.belongs_to = id;
        }
        let resUsersData = await getUsersByRoleId(params1);
        return resUsersData;
    };

    const fetchLearners = async (id, books) => {
        let userdata = await fetchRoleWiseUser("learner", id);
        let soredLearners = sortBy(userdata.data, [
            (o) => {
                return o.name.firstname;
            },
        ]);
        getAttemptedBooks(books, soredLearners);
    };

    const getAttemptedBooks = async (allBooks, allLeraners) => {
        // console.log("allBooks", allBooks);
        // console.log("allLeraners", allLeraners);        
        let updatedAt = '';
        let assessmentYearVal = [];
        if (selectedAssessmentYear) {
            assessmentYearVal = selectedAssessmentYear.split("_");
        } else {
            assessmentYearVal = assessmentYearItems[0]['value'].split("_");
        }
        console.log("getAttemptedBooks=====>", assessmentYearVal);
        updatedAt = { $and: { $gt: assessmentYearVal[0], $lt: assessmentYearVal[1] } }

        let booksIds = map(allBooks, "asset_uid");
        let userIds = map(allLeraners, "uid");
        let logs = await getUserLog({
            $limit: -1,
            site_uuid: userInfo.site_uuid,
            actor: userIds,
            context: {
                assetId: {
                    $in: booksIds,
                },
            },
            verb: "attemptAssignment",
            updated_at: updatedAt
        });

        let newArr = allLeraners.map((val) => {
            let count = 0;
            let booksArr = allBooks.map((book) => {
                let foundObj = find(logs.data, (o) => {
                    return o.actor == val.uid && o.context.assetId == book.asset_uid;
                });
                if (foundObj) {
                    count++;
                }
                return {
                    bookname: book.asset_name,
                    bookid: book.asset_uid,
                    attempted: foundObj ? true : false,
                };
            });
            return {
                ...val,
                attemptedBooks: count,
                books: booksArr,
            };
        });

        if (selectedSort == "Attempted Books") {
            newArr = orderBy(newArr, ["attemptedBooks"], ["desc"]);
        }
        setLearners(newArr);
        dispatch(commonSliceActions.setLoader(false));
    };

    const handleChange = (arg) => {
        dispatch(commonSliceActions.setLoader(true));
        setselectedClass(arg.target.value);
        standardName(arg.target.value);
        fetchLearners(arg.target.value, books);
    };

    const handleAssessmentYearChange = (itemData) => {        
        setAssessmentYear(itemData.label);
        setSelectedAssessmentYear(itemData.value);
    };

    const handleChangeClassName = (event) => {
        setSelectedClassName(event.target.value)
    };

    const standardName = (id) => {
        let foundObj = find(allClasses, { id: id });
        let className = 'NA';
        if (foundObj) {
            className = foundObj.value;
        }
        setSelectedClassName(className);
        return
    };

    const handleChangeInstitute = (event) => {
        //const { name, value } = event.target;
        //setUserData({ ...userData, [name]: value });
        setInstituteName(event.target.value);
    };

    const downloadPDF = () => {
        let element = document.getElementById('pdfid');
        let opt = {
            margin: 0,
            filename: `ReaderBoardCertificate_${selectedClassName}.pdf`,
            jsPDF: { unit: 'pt', format: 'a4', orientation: 'portrait' }
        };
        //html2pdf(element,opt);
        html2pdf().from(element).set(opt).toPdf().save();
    };


    return (
        <>
            <Grid container>
                <Grid item xs={12}>
                    <Grid container justifyContent={"space-between"}>
                        <Grid item>
                            <Typography variant="h5" color={"#DB8829"} mt={1}>
                                Reader Board Certificates
                            </Typography>
                        </Grid>
                        <Grid>
                            <Box sx={{ display: "flex", alignItems: 'center' }}>
                                <IconButton color="primary" onClick={() => downloadPDF()}>
                                    <CloudDownloadIcon sx={{ fontSize: "2.4vw" }} />
                                </IconButton>
                                <Box sx={{ mt: 1 }}>
                                    {'Original'}
                                    <Switch
                                        checked={isActive}
                                        size="small"
                                        inputProps={{ "aria-label": "controlled" }}
                                        color="primary"
                                        onChange={() => {
                                            setIsActive(!isActive);
                                        }}
                                    />
                                </Box>
                                <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
                                    <InputLabel
                                        sx={{
                                            "@media (min-width: 1636px)": {
                                                fontSize: "1.2rem",
                                            },
                                        }}
                                    >
                                        Class
                                    </InputLabel>
                                    <Select
                                        autoWidth
                                        value={selectedClass}
                                        label="Class"
                                        onChange={handleChange}
                                        sx={{
                                            borderRadius: 10,
                                            "@media (min-width: 1636px)": {
                                                fontSize: "1.4rem",
                                            },
                                        }}
                                    >
                                        {allClasses &&
                                            allClasses.map((obj, ind) => {
                                                return (
                                                    <MenuItem
                                                        key={`${ind}_class`}
                                                        value={obj.id}
                                                        sx={{
                                                            "@media (min-width: 1636px)": {
                                                                fontSize: "1.4rem",
                                                            },
                                                        }}
                                                    >
                                                        {obj.value}
                                                    </MenuItem>
                                                );
                                            })}
                                    </Select>
                                </FormControl>
                            </Box>
                        </Grid>
                    </Grid>
                    <Grid container sx={{ flexDirection: 'row', justifyContent: 'flex-start' }} >
                        <Grid sx={{ mx: 1 }}>
                            <InputLabel sx={{
                                m: 1,
                                '@media (min-width: 1636px)': {
                                    fontSize: '1.2rem',
                                }
                            }}>Enter Institute Name</InputLabel>
                            <TextField
                                size="small"
                                required
                                id="outlined-required"
                                sx={{
                                    borderRadius: 50,
                                }}

                                InputProps={{
                                    inputProps: {
                                        sx: {
                                            color: "#DB8829",
                                            fontSize: "0.9rem",
                                            fontWeight: "500",
                                            width: "30ch",
                                            '@media (min-width: 1636px)': {
                                                fontSize: '1.4rem',
                                                width: "35ch"
                                            }

                                        },
                                    },
                                    sx: { borderRadius: 50 },
                                }}
                                name={"instituteName"}
                                value={instituteName}
                                onChange={handleChangeInstitute}
                            />
                        </Grid>
                        <Grid sx={{ mx: 1 }}>
                            <InputLabel sx={{
                                m: 1,
                                '@media (min-width: 1636px)': {
                                    fontSize: '1.2rem',
                                }
                            }}>Class Name</InputLabel>
                            <TextField
                                size="small"
                                required
                                id="outlined-required"
                                sx={{
                                    borderRadius: 50,
                                }}
                                InputProps={{
                                    inputProps: {
                                        sx: {
                                            color: "#DB8829",
                                            fontSize: "0.9rem",
                                            fontWeight: "500",
                                            width: "15ch",
                                            '@media (min-width: 1636px)': {
                                                fontSize: '1.4rem',
                                                width: "35ch"
                                            }

                                        },
                                    },
                                    sx: { borderRadius: 50 },
                                }}
                                name={"selectedClassName"}
                                value={selectedClassName}
                                onChange={handleChangeClassName}
                            />
                        </Grid>
                        <Grid sx={{ mx: 1 }}>
                            <InputLabel sx={{
                                m: 1,
                                '@media (min-width: 1636px)': {
                                    fontSize: '1.2rem',
                                }
                            }}>Academic Year</InputLabel>
                            <FormControl sx={{ minWidth: 160 }} size="small">
                                <Select
                                    autoWidth
                                    value={assessmentYear}
                                    sx={{
                                        borderRadius: 10,
                                        "@media (min-width: 1636px)": {
                                            fontSize: "1.4rem",
                                        },
                                    }}
                                >
                                    {assessmentYearItems &&
                                        assessmentYearItems.map((itemData, ind) => {
                                            return (
                                                <MenuItem
                                                    key={`${ind}_year`}
                                                    value={itemData.label}
                                                    sx={{
                                                        "@media (min-width: 1636px)": {
                                                            fontSize: "1.4rem",
                                                        },
                                                    }}
                                                    onClick={() => { handleAssessmentYearChange(itemData) }}
                                                >
                                                    {itemData.label}
                                                </MenuItem>
                                            );
                                        })}
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            {
                learners && learners.length > 0 &&
                <Grid
                    container
                    spacing={0}
                    className={styles.scrollBar}
                    sx={{
                        height: "65vh",
                        overflow: "auto",
                        flexDirection: "row",
                        justifyContent: "space-around",
                        alignItems: "center",
                        marginTop: '20px',
                    }}
                >
                    <Box id="pdfid" >
                        {learners.map((objUser, index) => {
                            return (
                                <>
                                    {(index > 0) &&
                                        <div class="html2pdf__page-break"></div>
                                    }
                                    <table align="center" border="0" cellpadding="0" cellspacing="0" width="755"
                                        style={{ border: isActive ? '1px solid #CCC' : '0px solid', backgroundColor: isActive ? '#404F93' : ``, backgroundColor: isActive ? '#404F93' : '#FFF' }}>
                                        <tr>
                                            <td>
                                                <table align="center" border="0" cellpadding="0" cellspacing="0" width="755"
                                                    style={{ background: 'white', margin: '20px' }}>
                                                    <tr style={{ visibility: isActive ? 'visible' : 'hidden' }}>
                                                        <td align="center" className="font" colspan="2"
                                                            style={{ background: `linear-gradient(to right, rgba(255,255,255,0) 0%,rgba(255,255,255,0) 3%,rgba(255,255,255,1) 4%,rgba(255,255,255,1) 96%,rgba(255,255,255,0) 97%,rgba(255,255,255,0) 100%)` }}>
                                                            <img src={require('../../assets/certi_logo.png')}
                                                                width="20%" style={{ marginTop: '45px' }} />
                                                        </td>
                                                    </tr>
                                                    <tr style={{ visibility: isActive ? 'visible' : 'hidden' }}>
                                                        <td colspan="2"
                                                            style={{ color: '#404F93', padding: '60px 50px 60px', textAlign: 'center', fontWeight: 'bolder', fontFamily: 'Montserrat', fontSize: '46px' }}>
                                                            <span style={{ color: '#E72C2D', fontSize: '68px' }}>CERTIFICATE</span><br />OF ACHIEVEMENT
                                                        </td>
                                                    </tr>
                                                    <tr style={{ visibility: 'visible' }}>
                                                        <td
                                                            style={{ color: '#404F93', textAlign: 'justify', padding: '10px 60px 124px', lineHeight: '1.8', fontWeight: '500', fontFamily: 'Montserrat', fontSize: '20px' }}>
                                                            <div style={{ display: 'inline-block' }}>
                                                                <div style={{ display: 'inline-block' }}>This certificate is awarded to</div>
                                                                <div
                                                                    style={{ borderBottom: '1px solid #404F96', fontWeight: '600', display: 'inline-block', width: '54%', textAlign: 'center' }}>
                                                                    {joinByKeys(
                                                                        objUser.name,
                                                                        ["firstname", "lastname"],
                                                                        " "
                                                                    )}</div>of&nbsp;
                                                                <div style={{ borderBottom: '1px solid #404F96', fontWeight: '600', display: 'inline-block', width: '10%', textAlign: 'center', lineHeight: '1.8' }}>
                                                                    {selectedClassName}
                                                                </div>&nbsp;at&nbsp;
                                                                <div style={{ borderBottom: '1px solid #404F96', fontWeight: '600', display: 'inline-block', width: '80%', textAlign: 'center', lineHeight: '1.8' }}>
                                                                    {instituteName}
                                                                </div>for completing the reading of&nbsp;
                                                                <div style={{ borderBottom: '1px solid #404F96', fontWeight: '600', display: 'inline-block', width: '8%', textAlign: 'center', lineHeight: '1.8' }}>
                                                                    {objUser.attemptedBooks}
                                                                </div>books in the academic year&nbsp;
                                                                <div style={{ borderBottom: '1px solid #404F96', fontWeight: '600', display: 'inline-block', width: '18%', textAlign: 'center', lineHeight: '1.8' }}>
                                                                    {assessmentYear}
                                                                </div>.
                                                                Your commitment to expanding your horizons and enriching your imagination through books has been exemplary.
                                                                Congratulations on this achievement!&nbsp;                                                                
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr
                                                        style={{ backgroundImage: `url('/logoback.png')`, backgroundSize: '110%', backgroundRepeat: 'no-repeat', visibility: isActive ? 'visible' : 'hidden' }}>
                                                        <td style={{ padding: '25px 0px 0px' }}>
                                                            <table width="100%" style={{ textAlign: 'center' }}>
                                                                <tr>
                                                                    <td width="100%" style={{ padding: '50px', position: 'relative', textAlign: '-webkit-center' }}>
                                                                        <table>
                                                                            <tr>
                                                                                <td colspan="2"
                                                                                    style={{ color: '#404F93', fontWeight: 'bolder', lineHeight: '1.4', fontFamily: 'Montserrat', fontSize: '22px', borderBottom: '1px solid #404F96', width: '180%', textAlign: 'center', paddingTop: '25px' }}>
                                                                                    <img src={require('../../assets/signature.png')} width="40%" />
                                                                                </td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td colspan="2"
                                                                                    style={{ color: '#404F93', lineHeight: '1.4', fontFamily: 'Montserrat', fontSize: '16px', textAlign: 'center' }}>
                                                                                    <b>Mr. Jasvinder Singh</b><br />
                                                                                    <b>CEO</b><br />
                                                                                    www.wordsworthelt.com
                                                                                </td>
                                                                            </tr>
                                                                        </table>
                                                                    </td>
                                                                </tr>
                                                            </table>
                                                        </td>
                                                    </tr>
                                                </table>
                                            </td>
                                        </tr>
                                    </table>
                                </>
                            )
                        })}
                    </Box>
                </Grid>
            }
        </>
    );
};
const useStyles = makeStyles({
    scrollBar: {
        "&::-webkit-scrollbar": {
            width: "0.6em",
        },
        "&::-webkit-scrollbar-track": {
            backgroundColor: "#ffe600ff",
            "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
            borderRadius: 5,
        },
        "&::-webkit-scrollbar-thumb": {
            backgroundColor: "#5f5600ff",
            borderRadius: 5,
        },
    },
});
export default ReaderBoardCertificate;
